export enum AppModalHorizontalPositionEnum {
    Left = 'left',
    Right = 'right',
    Center = 'center',
}
